import { store } from 'index';
import { SET_COMPONENTS_STATE } from 'actions/componentsActions';
import { componentsStateType } from 'reducer/types';

const closeVideoPlayer = () => {

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: componentsStateType) => store.dispatch(SET_COMPONENTS_STATE(payload));

    setComponentsState({
      ...componentsState,
      sender:         'closeVideoPlayer',
      showUserVideos: false,
    })
}

export default closeVideoPlayer;